import dataGrid from './components/data-grid.vue';
export { dataGrid as sDataGrid };


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/index.js
// module id = 24
// module chunks = 0